import { Component, OnInit } from '@angular/core';
import { HelperService } from '../core/services';
import { ActivatedRoute, NavigationEnd, NavigationStart, Params, Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-podcast',
  templateUrl: './podcast.component.html',
  styleUrls: ['./podcast.component.css']
})
export class PodcastComponent implements OnInit {

  previousRoute: string;
  disableNextUrl: boolean = true;
  disablePrevUrl: boolean = true;
  currentUrl: any = '';
  previousUrl: any = '';
  audioList: any = {};
  currentAudioIndex:any = 0;
  selectedAudio;
  objectKeys = Object.keys;

  constructor(private router: Router,private changeDetectorRef: ChangeDetectorRef,
    private helperSvc: HelperService) { }

  ngOnInit(): void {
    // this.previousRoute = this.helperSvc.getPreviousUrl();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        let currentUrl = this.router.url;

        this.disablePrevUrl = currentUrl == '/podcasts' ? true : false;
        this.disableNextUrl = currentUrl != '/podcasts' ? true : false;
      });
    this.router.events
      .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
      .subscribe((events: RoutesRecognized[]) => {

        this.previousUrl = events[0].urlAfterRedirects;

      });
      this.helperSvc.audioList$.subscribe(res => {
        // this.audioList = {};
        this.changeDetectorRef.detectChanges();
        this.audioList = res;
      })  //read the invoked data or default data
  }


}